import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Sun / Moon theme-switcher button.
 *
 * Single-click toggles between Light and Dark. The button shows the icon of
 * the *target* theme (so when you're in Light mode, it shows a Moon icon
 * meaning "switch to Dark") — same convention as GitHub, Linear, etc.
 *
 * The persisted preference is updated by useTheme().toggle, which also
 * mutates <html class="dark"> so Tailwind's `dark:` variants react instantly.
 */
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/store/theme';
export function ThemeToggle({ className }) {
    const { resolvedTheme, toggle } = useTheme();
    const isDark = resolvedTheme === 'dark';
    const Icon = isDark ? Sun : Moon;
    const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
    return (_jsx("button", { type: "button", onClick: toggle, title: label, "aria-label": label, "aria-pressed": isDark, className: [
            'inline-flex h-9 w-9 items-center justify-center rounded-md text-slate-600 transition-colors',
            'hover:bg-slate-100 hover:text-slate-900',
            'dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-50',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500',
            className ?? '',
        ].join(' '), children: _jsx(Icon, { className: "h-4 w-4", "aria-hidden": "true" }) }));
}
